import angular from 'angular';
import teamCalendarListCardComponent from './teamCalendarListCard.component';
import teamCalendarListCardDetail from './teamCalendarListCardDetail/teamCalendarListCardDetail';

let teamCalendarListCardModule = angular.module('teamCalendarListCard', [
  teamCalendarListCardDetail
])

  .component('teamCalendarListCard', teamCalendarListCardComponent)

  .name;

export default teamCalendarListCardModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarListCard/teamCalendarListCard.js